import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { isCommandErrorCode, type CommandStatus } from "../store/admin/deviceCommandsStore";

const ERROR_CODE_SHAPE = /^[a-z][a-z0-9_]*$/;

export interface CommandText {
  label: (status: CommandStatus) => string;
  hint: (status: CommandStatus) => string;
  reason: (error?: string | null) => string | null;
}

export function useCommandText(): CommandText {
  const { t } = useTranslation("common");

  return useMemo(
    () => ({
      label: (status) => t(`commands.status.${status}`, { defaultValue: status }),
      hint: (status) => t(`commands.statusHint.${status}`, { defaultValue: "" }),
      reason: (error) => {
        const code = (error ?? "").trim();
        if (!code) return null;
        if (isCommandErrorCode(code)) return t(`commands.errors.${code}`);
        return ERROR_CODE_SHAPE.test(code) ? t("commands.errors.unknown", { code }) : null;
      },
    }),
    [t],
  );
}

export default useCommandText;
